import { Link } from "react-router-dom";
import { ArrowRight, MessageSquare, Sparkles } from "lucide-react";
import { Button } from "@/shared/ui/button.jsx";
import { Badge } from "@/shared/ui/badge.jsx";
import plugMark from "@/assets/plug-mark.png";

/** Abertura da página institucional. */
export function Hero() {
  return (
    <section className="relative overflow-hidden py-24 md:py-32">
      {/* Brilho decorativo ao fundo. */}
      <div
        aria-hidden="true"
        className="pointer-events-none absolute left-1/2 top-0 h-[32rem] w-[32rem] -translate-x-1/2 rounded-full bg-primary/10 blur-3xl"
      />
      <img
        src={plugMark}
        alt=""
        aria-hidden="true"
        className="pointer-events-none absolute -right-12 top-12 h-72 w-72 rotate-12 opacity-5"
      />

      <div className="container relative z-10 mx-auto px-4 text-center">
        <Badge variant="secondary" className="mb-6 gap-1.5 rounded-full px-4 py-1.5">
          <Sparkles className="h-3.5 w-3.5 text-primary" />
          CRM odontológico com WhatsApp nativo
        </Badge>

        <h1 className="mx-auto max-w-4xl font-display text-4xl font-bold leading-tight tracking-tight md:text-6xl">
          A plataforma que faz sua clínica{" "}
          <span className="bg-gradient-to-r from-primary to-chart-2 bg-clip-text text-transparent">
            crescer de verdade
          </span>
        </h1>

        <p className="mx-auto mt-6 max-w-2xl text-lg leading-relaxed text-muted-foreground">
          Conecte gestão, marketing, WhatsApp e inteligência artificial em um único lugar. Do
          primeiro contato do paciente até a cadeira do consultório.
        </p>

        <div className="mt-10 flex flex-col items-center justify-center gap-4 sm:flex-row">
          <Button asChild size="lg" className="h-14 gap-2 rounded-full px-8 text-base">
            <a href="mailto:contato@odontoplug.com.br?subject=Quero uma demonstração">
              Solicitar demonstração
              <ArrowRight className="h-4 w-4" />
            </a>
          </Button>

          <Button asChild size="lg" variant="outline" className="h-14 gap-2 rounded-full px-8 text-base">
            <Link to="/login">
              <MessageSquare className="h-4 w-4" />
              Já sou cliente
            </Link>
          </Button>
        </div>

        <dl className="mx-auto mt-16 grid max-w-2xl grid-cols-2 gap-8 sm:grid-cols-3">
          {[
            { valor: "100%", rotulo: "em nuvem" },
            { valor: "WhatsApp", rotulo: "integração oficial Meta" },
            { valor: "LGPD", rotulo: "dados isolados por clínica" },
          ].map((item) => (
            <div key={item.rotulo} className="text-center">
              <dt className="font-display text-2xl font-bold text-primary">{item.valor}</dt>
              <dd className="mt-1 text-xs text-muted-foreground">{item.rotulo}</dd>
            </div>
          ))}
        </dl>
      </div>
    </section>
  );
}
